var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBroom = function SvgBroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66663 6L5.54 7.33333L3.26 3.46C2.88 2.83333 3.08 2.00666 3.70667 1.62666C4.33334 1.24666 5.16 1.44665 5.54 2.07332L7.66663 6Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88001 6.10664L5.77334 7.38667C4.54667 8.13334 4.17333 9.64 4.76667 10.84L6.13334 13.6267C6.57334 14.5267 7.64001 14.84 8.49334 14.3133L12.78 11.7067C13.64 11.1867 13.8467 10.1 13.2533 9.29333L11.4067 6.8C10.6067 5.72 9.10668 5.35998 7.88001 6.10664Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54 11.2067L10.64 13.0133",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 12.2467L8.93333 14.0533",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2467 10.1667L12.3467 11.9733",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBroom;